import { useGetIdentity, useStore } from "ra-core";
import { useMemo } from "react";

import type { FiltroPersonas } from "../dominio/equipo";

/**
 * Filtro por persona con selección múltiple de Leads, Pipeline y Agenda (Robert, 13/10/2026):
 * solo para administradores. Se recuerda la última selección de cada usuario (la misma en las
 * tres pantallas), en el store de ra-core de este navegador.
 */
export const useFiltroPersonas = (): [
  FiltroPersonas,
  (seleccion: FiltroPersonas) => void,
] => {
  const { identity } = useGetIdentity();
  const [guardada, guardar] = useStore<FiltroPersonas>(
    `nevora.personas.${identity?.id ?? "sin_sesion"}`,
    [],
  );
  const seleccion = useMemo(
    () =>
      Array.isArray(guardada)
        ? guardada.filter((s) => typeof s === "string")
        : [],
    [guardada],
  );
  return [seleccion, guardar];
};
